import { Injectable } from '@angular/core';
import { AuthenticationService } from 'app/helpers/authentication.service';
import { NotificationsService } from 'app/main/a2w/notifications/services/notifications-aniversario.service';
import { NotificationsAtividadesService } from 'app/main/a2w/notifications/services/notifications-atividades.service';
import { EnumFuncoes } from 'app/shared/enum.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToolbarService {

  private _qtdNotificacoes = new BehaviorSubject<number>(0);
  qtdNotificacoes$ = this._qtdNotificacoes.asObservable();
  qtdAniversario: number = 0;
  qtdAtividade: number = 0;

  constructor(private _notificationsService: NotificationsService,
    private _authService: AuthenticationService,
    private _notificationsAtividadesService: NotificationsAtividadesService
  ) {

  }

    origem: string;
    pagina: string;

    public async verificaNotificacoes() {
      if(!this._authService.currentUserValue) return;

      this._notificationsService.getAniversarios().then(res => {
        const aniversariosNaoLidos = res.filter(item => item.notificacaoLida === false);
        this.qtdAniversario = aniversariosNaoLidos?.length;

        if (!this._authService.currentUserValue.userDetails.userRules.find(userRules => userRules.funcao == EnumFuncoes.Administrador).ativo &&
            !this._authService.currentUserValue.userDetails.userRules.find(userRules => userRules.funcao == EnumFuncoes.Gestor).ativo &&
            !this._authService.currentUserValue.userDetails.userRules.find(userRules => userRules.funcao == EnumFuncoes.VendedorBalcão).ativo &&
            !this._authService.currentUserValue.userDetails.userRules.find(userRules => userRules.funcao == EnumFuncoes.VendedorCampo).ativo) {
              this.qtdAniversario = 0;
          }
        
  
        this._notificationsAtividadesService.getNotificacoesAtividades(this._authService.currentUserValue.userDetails.vendedorId).then(lista => {
            const atividadesNaoLidas = lista.filter(item => item.notificacaoLida === false);
            this.qtdAtividade = atividadesNaoLidas.length;    
            this._qtdNotificacoes.next(this.qtdAtividade + this.qtdAniversario);
        });
                      
      });     

    }
 
}
